import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  baseUrl: string = environment.reqBaseUrl + 'users/';

  constructor(private http: HttpClient) {}

  getUsers(type?: string) {
    if (type) {
      return this.http.get(this.baseUrl + 'type/' + type, {
        observe: 'response',
      });
    } else {
      return this.http.get(this.baseUrl + 'type/', {
        observe: 'response',
      });
    }
  }

  getAllUsers() {
    return this.http.get(this.baseUrl + 'all', {
      observe: 'response',
    });
  }

  getUserById(userId: string) {
    return this.http.get(this.baseUrl + userId, {
      observe: 'response',
    });
  }

  getUserCourses(userId: string) {
    return this.http.get(this.baseUrl + userId + '/courses/enrolled', {
      observe: 'response',
    });
  }

  getRegistrations() {
    return this.http.get(this.baseUrl + 'new/registration', {
      observe: 'response',
    });
  }

  approveUser(userId: string) {
    return this.http.put(this.baseUrl + 'approve/' + userId, {
      observe: 'response',
    });
  }

  rejectUser(userId: string) {
    return this.http.delete(this.baseUrl + 'disapprove/' + userId, {
      observe: 'response',
    });
  }

  addUser(payload: any) {
    return this.http.post(this.baseUrl, payload, {
      observe: 'response',
    });
  }

  updateUser(payload: any) {
    return this.http.put(this.baseUrl, payload, {
      observe: 'response',
    });
  }

  updateStatus(userId: string, payload: any) {
    return this.http.put(this.baseUrl + userId + '/status', payload, {
      observe: 'response',
    });
  }

  changePassword(payload: any) {
    return this.http.put(this.baseUrl + 'update/password', payload, {
      observe: 'response',
    });
  }

  sendInvite(payload: any) {
    return this.http.post(this.baseUrl + 'send/referral', payload, {
      observe: 'response',
    });
  }
}
